"use client";

import { useState } from "react";
import { X } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function RedefineYourBrandIdentity() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="relative bg-light-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground-light sm:text-4xl lg:text-5xl">
            Redefine Your Brand Identity
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Complete rebranding services to transform your business presence
          </p>
        </div>

        <Card className="mx-auto max-w-2xl cursor-pointer overflow-hidden rounded-xl p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_12px_hsl(45,95%,55%)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
          <Button variant="ghost" onClick={() => setIsOpen(true)} className="block w-full h-auto p-0 rounded-none hover:bg-transparent" aria-label="View brand board full size">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/sam_branding_complete_brand_board.png" alt="Sam Branding & Marketing - Complete Brand Board showcasing logo, colors, typography, and brand elements" className="h-auto w-full object-cover rounded-lg" />
          </Button>
        </Card>
      </div>

      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" onClick={() => setIsOpen(false)} role="dialog" aria-modal="true" aria-label="Brand board full screen view">
          <div className="relative max-h-[90vh] max-w-[90vw] animate-in zoom-in-95 duration-300" onClick={e => e.stopPropagation()}>
            <Button variant="secondary" size="icon" onClick={() => setIsOpen(false)} className="absolute -top-12 right-0 bg-background/80 text-foreground opacity-90 hover:opacity-100 shadow-soft" aria-label="Close full screen view">
              <X className="size-6" />
            </Button>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1438489/img/sam_branding_complete_brand_board.png" alt="Sam Branding & Marketing - Complete Brand Board showcasing logo, colors, typography, and brand elements" className="h-auto max-h-[90vh] w-auto max-w-full rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.16),0_0_24px_hsl(45,95%,55%)]" />
          </div>
        </div>}
    </section>;
}